// extracted by mini-css-extract-plugin
module.exports = {"chipRoot":"chip-module__chipRoot___JZneG","chipLabel":"chip-module__chipLabel___xZutc","closeSvg":"chip-module__closeSvg___304YS"};